import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationTextMessage } from '@app/core/Enum';
import { TicketStatus } from '@app/core/Enum/ticket';
import { CommonService } from '@app/core/Services';
import { GetAllSupportTickets } from '@app/core/Store';
import { TicketDialogComponent } from '@app/modules';
import { Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.scss'],
})
export class SupportTicketComponent implements OnInit {
  externalUserGUID = this.cookieService.get(
    'externalUserGUID'
  ) as unknown as Guid;
  supportTicketList: any[];
  ticketStatus = TicketStatus;
  selectedStatus = this.ticketStatus.All;
  commonNotificationText = NotificationTextMessage;
  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
    'id',
    'subject',
    'createdOn',
    'status',
    'groupName',
  ];

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    private store: Store,
    private cookieService: CookieService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getList();
  }

  getList(): void {
    if (
      this.externalUserGUID !== null &&
      this.externalUserGUID !== this.commonService.defaultGuidValue
    ) {
      this.store
        .dispatch(new GetAllSupportTickets(this.externalUserGUID))
        .subscribe((res) => {
          this.supportTicketList = res.ticket.supportTicketList;
          this.dataSource = new MatTableDataSource(this.supportTicketList);
          this.dataSource.sort = this.sort;

          this.onSelectionChange();
        });
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(TicketDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getList();
      }
    });
  }

  onSearch(event: any): void {
    const searchText = event.target.value;

    this.dataSource.filter = searchText.trim().toLowerCase();
  }

  onSelectionChange(): void {
    this.dataSource = new MatTableDataSource(this.supportTicketList);

    if (this.selectedStatus !== 1) {
      this.dataSource.data = this.dataSource.data.filter(
        (element) => element.status === this.selectedStatus
      );
    }
  }
}
